export type ReportFiltersBeforeMountContext = {
  isDashboard: boolean;
  subReport: boolean;
  filterPromise: Promise<unknown>;
  clearFilter: () => void;
  setSorting: () => void;
  onFiltersActive: () => void;
};

export const runReportFiltersBeforeMount = (context: ReportFiltersBeforeMountContext) => {
  if (context.isDashboard || context.subReport) {
    return;
  }

  context.filterPromise.then(() => {
    context.onFiltersActive();
    context.setSorting();
    context.clearFilter();
  });
};
